import type { FC } from 'react';
import { HashRouter, Route, Routes } from 'react-router';
import { UserInfoLoading } from './UserInfoLoading';
import { LoginPage } from './LoginPage';
import { LogoutSuccess } from './LogoutSuccess';

/**
 * Renders content for a user who does not have user info.
 * If this UI is shown in an iframe, or has been opened by another window, assume
 * that the parent/opener window will pass in the user info after a brief delay,
 * so just show loading animation.
 * Otherwise, show a Login UI for the end-user to enter their info.
 *
 * Authentication is handled server-side via /auth/login and /auth/callback.
 * The server creates the session and sets the cookie, then redirects here.
 */
export const Public: FC = () => {
  // If we're in an iframe or opened by another window, show loading
  if (window.top !== window.self || window.opener) {
    return <UserInfoLoading />;
  }

  // Show login page - redirects to /auth/login for server-side OIDC flow
  return (
    <div className="mf-chat-login fixed bg-secondary inset-0 flex flex-col items-center justify-center gap-4">
      <HashRouter>
        <Routes>
          <Route path="/logout" element={<LogoutSuccess />} />
          <Route path="*" element={<LoginPage />} />
        </Routes>
      </HashRouter>
    </div>
  );
};
